<template>
  <div class="withdrawal-option">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="hint">
            提现档位：配置金额、角标、新人专享；<strong>每日/累计次数填 0 表示不限</strong>；
            <strong>自动到账</strong>开启后该金额申请将自动支付宝打款（须已绑支付宝），失败仍进人工审核
          </div>
          <div class="action-group">
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增档位</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && list.length === 0" description="暂无提现档位" />

      <div v-else>
        <el-table
          :data="list"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在加载..."
          row-key="id"
        >
          <el-table-column prop="id" label="ID" width="70" align="center" />
          <el-table-column prop="amountYuan" label="提现金额(元)" min-width="120" align="center" />
          <el-table-column prop="tag" label="角标" min-width="120" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.tag" size="small" type="danger">{{ scope.row.tag }}</el-tag>
              <span v-else class="muted">—</span>
            </template>
          </el-table-column>
          <el-table-column label="新人专享" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.newbieOnly === 1" type="warning" size="small">是</el-tag>
              <span v-else class="muted">否</span>
            </template>
          </el-table-column>
          <el-table-column label="每日次数" width="110" align="center">
            <template slot-scope="scope">
              {{ formatLimit(scope.row.dailyLimit) }}
            </template>
          </el-table-column>
          <el-table-column label="累计次数" width="110" align="center">
            <template slot-scope="scope">
              {{ formatLimit(scope.row.lifetimeLimit) }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success" size="small">启用</el-tag>
              <el-tag v-else type="info" size="small">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="自动到账" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.autoPayout === 1" type="success" size="small">开</el-tag>
              <span v-else class="muted">关</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="small" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="isEdit ? '编辑提现档位' : '新增提现档位'"
      :visible.sync="dialogVisible"
      width="520px"
      append-to-body
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="提现金额" prop="amountYuan">
          <el-input-number
            v-model="form.amountYuan"
            :min="0.01"
            :step="0.1"
            :precision="2"
            controls-position="right"
          />
          <div class="form-tip">单位：元（申请时按 1元=10000 金币换算）</div>
        </el-form-item>
        <el-form-item label="角标" prop="tag">
          <el-input v-model.trim="form.tag" maxlength="32" placeholder="如：新人专享 / 每日一次，可空" />
        </el-form-item>
        <el-form-item label="新人专享" prop="newbieOnly">
          <el-switch
            v-model="form.newbieOnly"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否"
          />
        </el-form-item>
        <el-form-item label="每日次数" prop="dailyLimit">
          <el-input-number v-model="form.dailyLimit" :min="0" :step="1" controls-position="right" />
          <div class="form-tip">0 = 不限次数</div>
        </el-form-item>
        <el-form-item label="累计次数" prop="lifetimeLimit">
          <el-input-number v-model="form.lifetimeLimit" :min="0" :step="1" controls-position="right" />
          <div class="form-tip">0 = 不限次数</div>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          />
        </el-form-item>
        <el-form-item label="自动到账" prop="autoPayout">
          <el-switch
            v-model="form.autoPayout"
            :active-value="1"
            :inactive-value="0"
            active-text="开"
            inactive-text="关"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, put, del, getResponseMessage } from '@/utils/http.js'

export default {
  name: 'WithdrawalOptionManagement',
  data() {
    return {
      loading: false,
      submitting: false,
      error: '',
      list: [],
      pagination: { page: 1, pageSize: 20, total: 0 },
      dialogVisible: false,
      isEdit: false,
      editId: null,
      form: this.emptyForm(),
      rules: {
        amountYuan: [{ required: true, message: '请输入提现金额', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatLimit(val) {
      if (val == null || val === 0) return '不限'
      return String(val)
    },
    emptyForm() {
      return {
        amountYuan: 1,
        tag: '',
        newbieOnly: 0,
        dailyLimit: 0,
        lifetimeLimit: 0,
        status: 1,
        autoPayout: 0
      }
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const res = await get('/admin/withdrawal-option/page', {
          pageNum: this.pagination.page,
          pageSize: this.pagination.pageSize
        })
        const data = res.data || {}
        this.list = data.records || []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.list = []
        this.error = e.message || '加载失败'
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.isEdit = false
      this.editId = null
      this.form = this.emptyForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.form = {
        amountYuan: Number(row.amountYuan),
        tag: row.tag || '',
        newbieOnly: row.newbieOnly == null ? 0 : row.newbieOnly,
        dailyLimit: row.dailyLimit == null ? 0 : row.dailyLimit,
        lifetimeLimit: row.lifetimeLimit == null ? 0 : row.lifetimeLimit,
        status: row.status == null ? 1 : row.status,
        autoPayout: row.autoPayout == null ? 0 : row.autoPayout
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const payload = {
            amountYuan: this.form.amountYuan,
            tag: this.form.tag || null,
            newbieOnly: this.form.newbieOnly,
            dailyLimit: this.form.dailyLimit,
            lifetimeLimit: this.form.lifetimeLimit,
            status: this.form.status,
            autoPayout: this.form.autoPayout
          }
          if (this.isEdit) {
            await put(`/admin/withdrawal-option/${this.editId}`, payload)
            this.$message.success('更新成功')
          } else {
            await post('/admin/withdrawal-option', payload)
            this.$message.success('创建成功')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(getResponseMessage(e) || e.message || '保存失败')
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确定删除「${row.amountYuan} 元」档位吗？`, '提示', { type: 'warning' })
        .then(async () => {
          try {
            await del(`/admin/withdrawal-option/${row.id}`)
            this.$message.success('已删除')
            this.fetchList()
          } catch (e) {
            this.$message.error(getResponseMessage(e) || e.message || '删除失败')
          }
        })
        .catch(() => {})
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.withdrawal-option {
  padding: 0;
}
.filter-card {
  margin-bottom: 16px;
}
.filter-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.hint {
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}
.form-tip {
  margin-top: 4px;
  color: #94a3b8;
  font-size: 12px;
}
.muted {
  color: #94a3b8;
}
.danger-text {
  color: #ef4444;
}
.error {
  color: #ef4444;
  margin-bottom: 12px;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
</style>
